const DEFAULT_BASE_URL = (process.env.REACT_APP_MANUAL_API_BASE_URL || 'https://redcuida-deef6d0c85e4.herokuapp.com').replace(/\/$/, '');

export const MANUAL_API_BASE_URL = DEFAULT_BASE_URL;

export async function fetchManualIndex(signal) {
  const response = await fetch(`${DEFAULT_BASE_URL}/manual`, {
    headers: {
      Accept: 'application/json',
    },
    signal,
  });

  if (!response.ok) {
    throw new Error('No se pudo cargar el índice del manual.');
  }

  return response.json();
}

export async function fetchManualSection(slug, signal) {
  const normalizedSlug = encodeURI(slug.replace(/^\/+|\/+$/g, ''));
  const response = await fetch(`${DEFAULT_BASE_URL}/manual/${normalizedSlug}`, {
    headers: {
      Accept: 'application/json',
    },
    signal,
  });

  if (!response.ok) {
    throw new Error('No se pudo cargar la sección solicitada.');
  }

  return response.json();
}

export function getManualAssetUrl(assetPath) {
  if (!assetPath) {
    return null;
  }

  if (/^https?:\/\//i.test(assetPath)) {
    return assetPath;
  }

  const cleanedPath = assetPath.replace(/^\/+/, '');
  return `${DEFAULT_BASE_URL}/manual/assets/${encodeURI(cleanedPath)}`;
}

